module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.12631ad7.ttf";